var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJiraRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "#fff",
    stroke: "#DBDDE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.216 26.925 30.61 13.318 29.29 12 19.05 22.242l-4.684 4.683a1.255 1.255 0 0 0 0 1.77l9.358 9.357 5.568 5.568 10.241-10.243.16-.158 4.524-4.517a1.253 1.253 0 0 0 0-1.777zm-14.925 5.56-4.675-4.675 4.675-4.675 4.674 4.675-4.674 4.675z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.291 23.136a7.87 7.87 0 0 1-.033-11.097l-10.23 10.226 5.567 5.567 4.697-4.697z",
    fill: "url(#3qo7q402qa)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33.978 27.797-4.687 4.688a7.872 7.872 0 0 1 0 11.132L39.55 33.364l-5.572-5.567z",
    fill: "url(#psa6pcl85b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3qo7q402qa",
    x1: 28.454,
    y1: 18.405,
    x2: 21.926,
    y2: 24.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "psa6pcl85b",
    x1: 30.184,
    y1: 37.158,
    x2: 36.7,
    y2: 30.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraRounded);
export default __webpack_public_path__ + "static/media/jira-rounded.4ddbf470b27a54dd4f97ddb9d761b830.svg";
export { ForwardRef as ReactComponent };